import React from 'react';
import { useAuth } from '../contexts/AuthContext';

export default function InactiveAccount() {
  const { user } = useAuth();
  const isOwner = user?.role === 'owner';
  const isStaff = user?.role === 'staff';

  return (
    <div className="container d-flex justify-content-center align-items-center min-vh-100">
      <div className="card shadow" style={{ maxWidth: 520, width: '100%' }}>
        <div className="card-body text-center">
          <div className="mb-3">
            <span className="badge bg-warning text-dark">Account Inactive</span>
          </div>
          <h3 className="card-title mb-3">Your account is inactive</h3>
          {isOwner && (
            <p className="card-text text-muted mb-4">
              Please contact support or the system administrator to reactivate your business owner account.
            </p>
          )}
          {isStaff && (
            <p className="card-text text-muted mb-4">
              Your access is disabled because your staff account or your owner's account is inactive.
              Please contact your business owner or administrator.
            </p>
          )}
          {!isOwner && !isStaff && (
            <p className="card-text text-muted mb-4">
              Please contact the administrator.
            </p>
          )}
          <div className="d-grid gap-2">
            <button
              className="btn btn-outline-secondary"
              onClick={() => {
                localStorage.removeItem('token');
                window.location.href = '/login';
              }}
            >
              Logout
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
